export const JOB_TITLES = [
  { id: 'ua', label: 'UA Manager' },
  { id: 'creative', label: 'Creative Manager' },
  { id: 'cmo', label: 'CMO' },
  { id: 'cfo', label: 'CFO' },
] as const;

export const tableColumns = '3fr 1fr 1fr 1fr 50px';
